<mat-table [dataSource]="groupedCompanyAdmins" class="platform-mat-table">
  <ng-container matColumnDef="logo">
    <mat-header-cell *matHeaderCellDef>Logo</mat-header-cell>
    <mat-cell *matCellDef="let admin" class="logo-cell">
      <img
        *ngIf="admin.logoUrl"
        class="org-logo"
        [src]="admin.logoUrl"
        [alt]="admin.orgDisplayName + ' logo'"
        loading="lazy"
        decoding="async"
        (error)="handleLogoError($event)"
      />
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="org">
    <mat-header-cell *matHeaderCellDef>Organization</mat-header-cell>
    <mat-cell *matCellDef="let admin">{{ admin.orgDisplayName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="email">
    <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
    <mat-cell *matCellDef="let admin">
      {{ admin.email || 'N/A' }}
      <mat-icon
        *ngIf="isInvitePending(admin)"
        class="invite-pending-icon"
        [matTooltip]="invitePendingTooltip"
        [attr.aria-label]="invitePendingTooltip">
        schedule
      </mat-icon>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
    <mat-cell *matCellDef="let admin">{{ (admin.name || '') + ' ' + (admin.surname || '') }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="billingOwner">
    <mat-header-cell *matHeaderCellDef>Billing Owner</mat-header-cell>
    <mat-cell *matCellDef="let admin">{{ admin.isBillingOwner ? 'Yes' : 'No' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="approvalStatus">
    <mat-header-cell *matHeaderCellDef>Approval</mat-header-cell>
    <mat-cell *matCellDef="let admin">
      <mat-chip [color]="admin.approvalStatus === 'APPROVED' ? 'primary' : 'accent'">
        {{ admin.approvalStatus }}
      </mat-chip>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
    <mat-cell *matCellDef="let admin" class="action-cell">
      <button
        mat-icon-button
        [matMenuTriggerFor]="adminActionsMenu"
        [matMenuTriggerData]="{ admin: admin }"
        matTooltip="Company admin actions"
        aria-label="Open company admin actions menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <mat-menu #adminActionsMenu="matMenu">
    <ng-template matMenuContent let-admin="admin">
      <button mat-menu-item (click)="viewDocument(admin)" [disabled]="!admin.idDocumentAvailable">
        <mat-icon>badge</mat-icon>
        <span>View Legal Info</span>
      </button>

      <button
        *ngIf="isAwaitingReview(admin)"
        mat-menu-item
        (click)="approveMembership(admin.membershipId)"
        [disabled]="loading">
        <mat-icon>check_circle</mat-icon>
        <span>Approve</span>
      </button>

      <button
        *ngIf="isAwaitingReview(admin)"
        mat-menu-item
        (click)="rejectMembership(admin.membershipId)"
        [disabled]="loading">
        <mat-icon>cancel</mat-icon>
        <span>Reject</span>
      </button>

      <button
        *ngIf="admin.approvalStatus === 'APPROVED'"
        mat-menu-item
        (click)="resetAdminPassword(admin)"
        [disabled]="loading">
        <mat-icon>lock_reset</mat-icon>
        <span>Reset Password</span>
      </button>

      <button
        mat-menu-item
        *ngIf="isInvitePending(admin)"
        (click)="resendAdminInvite(admin)"
        [disabled]="loading">
        <mat-icon>forward_to_inbox</mat-icon>
        <span>Resend Invite</span>
      </button>

      <button
        mat-menu-item
        (click)="deleteAdmin(admin)"
        [disabled]="loading || isDeleteBlocked(admin)"
        [matTooltip]="isDeleteBlocked(admin) ? deleteBlockedTooltip : ''">
        <mat-icon color="warn">delete</mat-icon>
        <span>Delete</span>
      </button>
    </ng-template>
  </mat-menu>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row
    *matRowDef="let row; let i = index; columns: displayedColumns"
    [class.org-group-start]="isGroupStart(i)"></mat-row>
</mat-table>

<div class="table-empty-state" *ngIf="companyAdmins.length === 0">
  No company admins found.
</div>
